import React, { useState } from 'react';

const Locations = () => {
  const [expandedImage, setExpandedImage] = useState<string | null>(null);
  const locations = [
    {
      id: 1,
      name: "Caring Haven Harbour Landing - 4024 Delhaye Way",
      address: "4024 Delhaye Way, Regina South (Harbour Landing), SK",
      capacity: "0 Vacancy",
      status: "Fully Occupied",
      image: "/images/4024.jpg",
      features: ["Brand New Building", "Modern Facilities", "Harbour Landing Community", "Premium Location"],
      services: [
        "Personal Care Assistance",
        "Medication Management", 
        "24/7 Nursing Care",
        "Nutritious Meals",
        "Social Activities",
        "Housekeeping",
        "Laundry Services",
        "Emergency Response"
      ],
      specialty: "Premium personal care home in the desirable Harbour Landing area"
    },
    {
      id: 2,
      name: "Caring Haven Harbour Landing - 4016 Delhaye Way",
      address: "4016 Delhaye Way, Regina South (Harbour Landing), SK",
      capacity: "10 beds",
      status: "Licensing in Progress - Taking Reservations",
      image: "/images/4016.jpg",
      features: ["Brand New Building", "Taking Reservations", "Harbour Landing Community", "Modern Design"],
      services: [
        "Personal Care Assistance",
        "Medication Management",
        "24/7 Nursing Care",
        "Nutritious Meals",
        "Social Activities",
        "Housekeeping",
        "Laundry Services",
        "Emergency Response"
      ],
      specialty: "New facility opening soon in Harbour Landing, now accepting reservations"
    },
    {
      id: 3,
      name: "Caring Haven Harbour Landing - 5505 Waterer Rd",
      address: "5505 Waterer Rd, Regina South (Harbour Landing), SK",
      capacity: "16 suites with 4 specialized units",
      status: "Building Soon",
      image: "/images/elevation.jpg",
      features: ["16 Suites", "4 Specialized Units", "Community Accommodation", "Premium Design"],
      services: [
        "Personal Care Assistance",
        "Specialized Care Units",
        "Community Programs",
        "Modern Amenities",
        "Professional Staff",
        "Nutritious Meals",
        "Social Activities",
        "Transportation Services"
      ],
      specialty: "Large-scale facility with specialized care units and community accommodations"
    },
    {
      id: 4,
      name: "Caring Haven Kensington Greens - 1325 N. Kingbird Rd",
      address: "1325 N. Kingbird Rd, Regina North (Kensington Greens), SK",
 
      capacity: "TBD",
      status: "Building Soon",
      image: "/images/elevation.jpg",
      features: ["Brand New Building", "Kensington Greens Community", "Modern Design", "Quality Construction"],
      services: [
        "Personal Care Assistance",
        "Medication Management",
        "24/7 Nursing Care",
        "Nutritious Meals",
        "Social Activities",
        "Housekeeping",
        "Laundry Services",
        "Emergency Response"
      ],
      specialty: "New facility coming to the established Kensington Greens neighborhood"
    },
    {
      id: 5,
      name: "Caring Haven Kensington Greens - 1401 N. Kingbird Rd",
      address: "1401 N. Kingbird Rd, Regina North (Kensington Greens), SK",
 
      capacity: "TBD",
      status: "Building Soon",
      image: "/images/elevation.jpg",
      features: ["Brand New Building", "Kensington Greens Community", "Modern Design", "Quality Construction"],
      services: [
        "Personal Care Assistance",
        "Medication Management",
        "24/7 Nursing Care",
        "Nutritious Meals",
        "Social Activities",
        "Housekeeping",
        "Laundry Services",
        "Emergency Response"
      ],
      specialty: "Additional facility expanding our presence in Kensington Greens"
    }
  ];

  const scrollToBooking = () => {
    const element = document.getElementById('booking');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const openGoogleMaps = (address: string) => {
    const encodedAddress = encodeURIComponent(address);
    const googleMapsUrl = `https://www.google.com/maps?q=${encodedAddress}`;
    window.open(googleMapsUrl, 'googleMaps', 'width=800,height=600,scrollbars=yes,resizable=yes');
  };

  const expandImage = (imageSrc: string) => {
    setExpandedImage(imageSrc);
  };

  const closeImageModal = () => {
    setExpandedImage(null);
  };

  return (
    <section className="locations">
      <div className="container">
        <div className="section-header">
          <h1>Our Locations</h1>
          <p>Five premium personal care facilities across Regina - brand new buildings raising the bar for personal care homes</p>
        </div>

        <div className="locations-grid">
          {locations.map((location) => (
            <div key={location.id} className="location-card">
              <div className="location-image">
                <img 
                  src={location.image} 
                  alt={location.name} 
                  onClick={() => expandImage(location.image)}
                  style={{ cursor: 'pointer' }}
                />
                <div className="location-capacity">
                  <span>{location.capacity}</span>
                </div>
                <div className="location-status">
                  <span>{location.status}</span>
                </div>
              </div>
              
              <div className="location-content">
                <h2>{location.name}</h2>
                <p className="location-specialty">{location.specialty}</p>
                
                <div className="location-contact">
                  <div className="contact-item">
                    <span className="icon">📍</span>
                    <span 
                      onClick={() => openGoogleMaps(location.address)}
                      style={{ cursor: 'pointer', color: '#007bff', textDecoration: 'underline' }}
                      title="Click to open in Google Maps"
                    >
                      {location.address}
                    </span>
                  </div>
                </div>

                <div className="location-features">
                  <h4>Key Features</h4>
                  <div className="features-list">
                    {location.features.map((feature, index) => (
                      <span key={index} className="feature-tag">
                        {feature}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="location-services">
                  <h4>Services Offered</h4>
                  <ul className="services-list">
                    {location.services.map((service, index) => (
                      <li key={index}>
                        <span className="service-check">✓</span>
                        {service}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="location-actions">
                  <button 
                    className="btn-primary"
                    onClick={scrollToBooking}
                  >
                    Schedule Visit
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="locations-cta">
          <div className="cta-content">
            <h3>Not sure which location is right for you?</h3>
            <p>Our care coordinators can help you choose the perfect facility based on your specific needs and preferences.</p>
            <div className="cta-buttons">
              <button 
                className="btn-primary"
                onClick={scrollToBooking}
              >
                Schedule Consultation
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Image Modal */}
      {expandedImage && (
        <div 
          className="image-modal"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
            cursor: 'pointer'
          }}
          onClick={closeImageModal}
        >
          <div 
            style={{
              position: 'relative',
              maxWidth: '90%',
              maxHeight: '90%',
              backgroundColor: 'white',
              borderRadius: '8px',
              padding: '20px',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={closeImageModal}
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                background: 'none',
                border: 'none',
                fontSize: '24px',
                cursor: 'pointer',
                color: '#666',
                zIndex: 1001
              }}
              title="Close"
            >
              ×
            </button>
            <img 
              src={expandedImage} 
              alt="Expanded view"
              style={{
                width: '100%',
                height: 'auto',
                maxWidth: '800px',
                maxHeight: '600px',
                objectFit: 'contain',
                borderRadius: '4px'
              }}
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default Locations;